export default {
  route: {
    dashboard: 'Home',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    dragDialog: 'Drag Dialog',
    dragSelect: 'Drag Select',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    menu2: 'Menu 2',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Profile',
    translationmanager: 'TranslationManager',
    commoditymanager: 'CommodityManager',
    ordermanager: 'OrderManager',
    inboundscanning: 'InboundScanning',
    systemmanager: 'SystemManager',
    platformconfiguration: 'StoreConfiguration',
    storedetail: 'StoreDetail',
    memberlist: 'MemberList',
    rolemanager: 'RoleManager',
    warehousemanager: 'WarehouseManager',
    putinwarehouse: 'PutIn',
    putoutwarehouse: 'PutOut',
    putoutwarehouseold: '出库（旧）',
    csmanager: 'CSManager',
    platformorder: 'PlatformOrder',
    agentorder: 'AgentOrder',
    dictmanager: 'DictManager',
    hscode: 'Hscode',
    translation: 'Translation',
    singleton: 'PieceUndertakes',
    helptobuy: '代买订单',
    syssetting: 'SystemSettings',
    inven: 'StockOrder',
    statementmanager: 'SettlementManager',
    orderlist: 'OrderList',
    statementlist: 'SettlementList',
    billlist: 'BillList',
    balancelist: 'BalanceSubsidiary',
    inventorymanager: 'InventoryManager',
    inventoryrecord: 'InventoryRecord',
    inventorylist: 'InventoryList',
    inventoryaudit: 'InventoryAudit',
    goodscates: 'GoodsCates',
    fee: 'FeeModel',
    price: '价格配置',
    balancedetail: 'BalanceDetail',
    cslist: '客户列表',
    agentlist: '代理列表',
    goodsdetail: '商品详情',
    uploadrecord: 'UploadRecord',
    agentorderdetail: 'OrderDetail',
    collectlist: '采集列表',
    datamanager: '数据管理',
    orderdata: '订单数据'
  },
  main: {
    updatepwd: 'UpdatePassword',
    logout: 'Logout',
    balance: 'Balance',
    cname: 'Customer name',
    ordercount: 'Order total',
    lastorderdate: 'Last order date',
    customcount: 'Customer count',
    copyurl: 'Copy promotion links',
    balance: 'Account balance',
    tatolcz: 'Accumulated top-up',
    morder: 'Month order count'
  },
  member: {
    role: 'Role',
    number: 'Number',
    username: 'Username',
    phone: 'Phone',
    ban: 'Ban',
    unban: 'UnBan',
    normal: 'Normal',
    addmember: 'AddMember',
    updatememer: 'UpdateMember',
    realname: 'RealName',
    password: 'Password'
  },
  custom: {
    name: 'Name',
    phone: 'Phone',
    ban: 'Ban',
    unban: 'UnBan',
    add: 'AddCustomer',
    update: 'UpdateCustomer',
    password: 'Password',
    country: 'Country',
    balance: 'Balance',
    consume: 'Consume',
    recharge: 'Recharge',
    refund: 'Refund',
    adminid: 'Creator',
    search: 'Enter the customer name or phone to search',
    currbalance: 'CurrentBalance',
    rechargeamount: 'RechargeAmount',
    authorizationcode: 'AuthorizationCode',
    com: 'Company',
    sendcount: 'Cumul delivery',
    cuscount: 'Customer Count',
    sy: 'Earnings'
  },
  agent: {
    search: 'Enter the tracking number to search',
    downloadxls: 'Download the standard form',
    date: 'Date',
    customername: 'CustomerName',
    couriernumber: 'CourierNumber',
    kcnumber: '库存数量',
    parcelnumber: 'DeliveryNumber',
    goodsnumber: 'TotalNumber',
    orderamount: 'OrderAmount',
    allprint: 'All Print',
    address: 'Address',
    phone: 'Phone',
    name: 'Name',
    danhao: 'Express No',
    danhaoko: 'Express No(ko)',
    gname: 'Goods Name',
    count: 'Count',
    idcard: 'IdCard',
    create: 'Create Order',
    edit: 'Edit Order',
    postcode: 'PostCode',
    goodsnamezh: 'Chinese Name',
    goodsnameen: 'English Name',
    price: 'Price',
    priced: 'Price($)',
    sendremark: 'Delivery remark',
    unit: 'Unit',
    material: 'Material',
    customer: 'Customer',
    weight: 'Weight',
    download: 'Download',
    count_in: 'InventoryIn',
    count_out: 'InventoryOut',
    count_send: 'ParcelCount',
    count_pkg: 'CourierCount',
    moresearch: 'More search',
    oldlist: 'Upload the record',
    inputgn: 'Enter the product name search',
    inputr: 'Enter recipient information to search',
    onlym: 'Only Merge List',
    remote: 'remote areas'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'LTL ERP',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    captacaa: 'Please hold down the slider and drag to the right',
    captacab: 'Verification Success',
    autologin: 'Automatic login within a week',
    forgotpwd: 'Forgot password',
    forgotpwdlabel: 'To reset your password',
    resetpwd: 'Reset password',
    pinputphone: 'Please enter the telephone number',
    getcode: 'Get sms code',
    backlogin: 'Return to login',
    register: 'Registered members',
    registerlabel: 'Registered members',
    pinputname: 'Please enter your name',
    pinputcode: 'Please enter a verification code',
    regis: 'Register',
    s: 's after Reacquire',
    success: 'Registered successfully！',
    suca: 'The initial password is 6 digits after the phone number，',
    sucb: 'Please go back to login！',
    sucd: 'Password reset successfully！',
    xts: 'The system prompt',
    hts: 'Complete the slide verification',
    ta: 'Oops, wrong click',
    tb: 'refresh',
    tc: 'Do it all over again',
    td: 'Reload'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  status: {
    all: 'All',
    checked: 'Checked',
    uncheck: 'UnCheck',
    waitcheck: 'WaitCheck',
    waitprint: 'WaitPrint',
    outwed: 'PutOut',
    inwed: 'PutIn',
    printed: 'Printed',
    checking: 'Checking',
    waitoutw: 'WaitOut',
    waitinw: 'WaitIn',
    inwing: 'Ining',
    outwing: 'Outing',
    waitsettle: 'WaitSettle',
    finish: 'Finish'
  },
  table: {
    empty: 'Temporarily no data',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    createtime: 'CreateTime',
    updatetime: 'UpdateTime',
    status: 'Status',
    print: 'Print',
    show: 'Show',
    amount: 'Amount',
    check: 'Check',
    remark_order: 'SellerRemark',
    volume: 'Volume',
    audit: 'Audit',
    invalid: 'Invalid',
    addmore: 'AddMore',
    record: 'Record'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  lan: {
    zh: 'China',
    ko: 'South Korea',
    en: 'The British',
    ja: 'Japan'
  },
  common: {
    upload: 'Upload',
    langSelect: 'Switch Language Success',
    actionSuccess: 'Action Success',
    pwdinit: 'The initial password is the last 6 digits of the phone number',
    inputsearch: 'Input Search...',
    noimg: 'No pictures of goods',
    rmb: 'RMB',
    krw: 'KRW',
    time: 'Time'
  },
  input: {
    name: 'Please enter name',
    phone: 'Please enter telephone number',
    address: 'Please enter the address',
    idcard: 'Please enter the customs clearance number',
    postcode: 'Please enter postcode',
    danhao: 'Please enter the tracking number',
    gnamecn: 'Please enter Chinese name',
    gnameen: 'Please enter the name in English',
    price: 'Please enter the price',
    remark: 'Please enter remarks',
    material: 'Please enter material',
    gname: 'Please enter the goods name',
    count: 'Please enter quantity',
    spec: 'Material/Color/Size'
  },
  check: {
    hscode: 'Please enter the correct product name'
  },
  upload: {
    ta: 'Upload the form file',
    tb: 'Drag the file here, or ',
    tc: 'Click on the upload',
    td: 'Only.xlsx/.xls files can be uploaded and no more than 5MB',
    te: 'Upload files only in.xlsx/.xls format!',
    tf: 'Upload file size cannot exceed 5MB!'
  },
  logout: {
    la: 'You have logged out. You can cancel your stay on the page or log in again',
    lb: 'Determine the logged out',
    lc: 'Log back in',
    ld: 'Cancel'
  },
  singleton: {
    da: 'Recipient information',
    db: 'Express information',
    dc: 'Merchandise information',
    merge: 'Merge',
    unmerge: 'BreakUp',
    couriercompany: 'CourierCompany',
    imgupload: 'UploadImages',
    imgadd: 'AddImages',
    create: 'New',
    inven: 'Inven',
    type: 'Type',
    shipping: 'Shipping',
    air: 'Air',
    spec: 'Specification'
  },
  picker: {
    start: 'Start date',
    end: 'End date',
    to: 'to',
    opa: 'Last week',
    opb: 'Last month',
    opc: 'Last 3 months'
  },
  inven: {
    create: 'CreateInventory',
    number: 'InvenNumber'
  },
  statement: {
    date: 'Select one or more dates',
    statement: 'Statement',
    total: 'Total',
    expressno: 'ExpressNo',
    outdate: 'OutDate',
    customer: 'Customer',
    receiver: 'Receiver',
    bill: 'Bill',
    statementcount: 'statementcount',
    weightsubtotal: 'weightsubtotal',
    type: 'CNY/KRW',
    costsubtotal: 'CostSubtotal',
    statementdate: 'StatementDate',
    statementer: 'Statementer',
    statementamount: 'StatementAmount',
    unstatementbill: 'UnStatementBill',
    out: 'Exporting report'
  },
  balance: {
    all: 'All',
    in: 'In',
    out: 'Out',
    time: 'Trading hours'
  },
  bill: {
    bcount: 'Settlement amount',
    m: 'Weight subtotal',
    t: 'Settlement type',
    f: 'Cost of subtotal',
    bf: 'Clearing fees',
    d: 'Settlement date'
  },
  od: {
    info: 'Order information',
    invo: 'Logistics information',
    oper: 'Operation records',
    upt: 'Upload time',
    int: 'Storage time',
    out: 'The delivery time',
    type: 'mode',
    zh: 'China section',
    hs: 'The customs',
    ko: 'South Korea section',
    opt: 'Operating time',
    opname: 'Operationer'
  }
}
